<template>
  <div id="pageItemList">
    <v-layout row class="align-center layout px-4 pt-4 app--page-header">
      <div class="page-header-left">
        <h3 class="pr-3">
          <v-icon>memory</v-icon>
          {{ $t("sparePartsForVehicle") }}: {{ vehicle.name }}
        </h3>
      </div>
      <!--      <v-breadcrumbs divider="-" :items="breadcrumbs"> </v-breadcrumbs>-->
    </v-layout>
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-text-field
                flat
                solo
                prepend-icon="search"
                :placeholder="$t('fulltextSearch')"
                v-model="searchInput"
                hide-details
                class="hidden-sm-and-down"
              ></v-text-field>
              <v-autocomplete
                name="spare_part_type"
                :label="$t('sparePartType')"
                :loading="sparePartTypeIsLoading"
                :items="sparePartTypes"
                :search-input.sync="sparePartTypeSearch"
                v-model="filter.type"
                cache-items
                item-text="name"
                item-value="id"
                clearable
              ></v-autocomplete>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="headers"
                :items="vehicleSpareParts"
                :rows-per-page-items="[10, 25, 50]"
                :pagination.sync="pagination"
                :total-items="vehicleSparePartsCount"
                :loading="vehicleSparePartsIsLoading"
                :expand="false"
                class="elevation-1"
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.type.name }}</td>
                  <td>{{ props.item.serial_number }}</td>
                  <td>
                    <action-tooltip
                      icon="details"
                      color="primary"
                      :tooltip="$t('details')"
                      @click="showAction(props.item.id)"
                    ></action-tooltip>
                    <action-tooltip
                      icon="history"
                      color="teal darken-3"
                      :tooltip="$t('showSparePartsHistoryTooltip')"
                      :disabled="props.item.original_part"
                      @click="showHistoryAction(props)"
                    ></action-tooltip>
                  </td>
                </template>
                <template slot="expand">
                  <v-container fluid>
                    <v-layout align-center justify-end row fill-height>
                      <v-flex md4>
                        <v-list subheader>
                          <v-subheader>{{
                            $t("showSparePartHistory")
                          }}</v-subheader>
                          <v-list-tile
                            v-for="item in vehicleSparePartHistory"
                            :key="item.serial_number"
                          >
                            <v-list-tile-content>
                              <v-list-tile-title>{{
                                item.serial_number
                              }}</v-list-tile-title>
                            </v-list-tile-content>

                            <v-list-tile-action>
                              <action-tooltip
                                icon="details"
                                color="primary"
                                :tooltip="$t('details')"
                                @click="showAction(item.id)"
                              ></action-tooltip>
                            </v-list-tile-action>
                          </v-list-tile>
                        </v-list>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <component :is="showDialogComponent" v-model="modalShow" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store";
import {
  FETCH_VEHICLE_SPARE_PARTS,
  FETCH_VEHICLE,
  FETCH_SPARE_PART,
  FETCH_VEHICLE_SPARE_PART_HISTORY,
  FETCH_SPARE_PART_TYPES
} from "@/store/actions.type";
import refreshButtonMixin from "@/mixins/refreshButton.mixin";
import searchInputMixin from "@/mixins/searchInput.mixin";
import paginationMixin from "@/mixins/pagination.mixin";
import SparePartsShowDialog from "@/views/SparePart/SparePartsShowDialog.vue";
import _ from "lodash";

export default {
  components: {
    "spare-parts-show-dialog": SparePartsShowDialog
  },
  data() {
    return {
      sparePartTypeSearch: "",
      filter: {
        type: null
      },
      pagination: {
        sortBy: "type.name",
        descending: false
      },
      headers: [
        { text: this.$t("name"), value: "type.name" },
        { text: this.$t("serialNumber"), value: "serialNumber" },
        { text: this.$t("actions"), sortable: false }
      ],
      modalShow: false,
      showDialogComponent: ""
    };
  },
  computed: {
    ...mapGetters([
      "vehicle",
      "vehicleSpareParts",
      "vehicleSparePartsCount",
      "vehicleSparePartsIsLoading",
      "vehicleSparePartHistory",
      "sparePartTypes",
      "sparePartTypeIsLoading"
    ])
  },
  watch: {
    modalShow: function(val) {
      if (val) {
        this.showDialogComponent = "spare-parts-show-dialog";
      } else {
        this.showDialogComponent = "";
      }
    },
    sparePartTypeSearch: _.debounce(function(val) {
      this.$store.dispatch(FETCH_SPARE_PART_TYPES, [{ rowsPerPage: -1 }, val]);
    }, 300),
    filter: {
      handler: function() {
        this.fetchItems();
      },
      deep: true
    }
  },
  mixins: [refreshButtonMixin, searchInputMixin, paginationMixin],
  methods: {
    fetchItems() {
      this.$store.dispatch(FETCH_VEHICLE_SPARE_PARTS, [
        this.vehicle.id,
        this.pagination,
        this.search,
        this.filter
      ]);
    },
    showAction(id) {
      this.$store.dispatch(FETCH_SPARE_PART, id).then(() => {
        this.modalShow = true;
      });
    },
    showHistoryAction(props) {
      if (props.expanded === true) {
        props.expanded = false;
      } else {
        this.$store
          .dispatch(FETCH_VEHICLE_SPARE_PART_HISTORY, [
            this.vehicle.id,
            props.item.id
          ])
          .then(() => {
            props.expanded = true;
          });
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    Promise.all([store.dispatch(FETCH_VEHICLE, to.params.vehicleId)]).then(
      () => {
        next();
      }
    );
  }
};
</script>

<style scoped></style>
